import React from 'react';
import { Pie } from '@ant-design/charts';

export interface DonutChartDatum {
  category: string;
  value: number;
}

export interface DonutChartProps {
  data: DonutChartDatum[];
  title?: string;
  height?: number;
}

const DonutChart: React.FC<DonutChartProps> = ({ data, title, height = 260 }) => {
  const config: any = {
    data: data.map((d) => ({
      type: d.category,
      value: d.value,
    })),
    angleField: 'value',
    colorField: 'type',
    radius: 1,
    innerRadius: 0.6,
    label: {
      text: 'value',
      style: {
        fontWeight: 'bold',
      },
    },
    legend: {
      color: {
        title: false,
        position: 'right',
        rowPadding: 5,
      },
    },
    annotations: [
      {
        type: 'text',
        style: {
          text: title || 'Visa\nStatus',
          x: '50%',
          y: '50%',
          textAlign: 'center',
          fontSize: 24,
          fontStyle: 'bold',
        },
      },
    ],
    height,
  };

  return <Pie {...config} />;
};

export default DonutChart;
